import React, { useEffect } from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import { usePrevious } from '@atlassian/jira-platform-react-hooks-use-previous/src/common/utils/index.tsx';
import { ContentSlider } from '../../common/ui/index.tsx';

export const ToolbarWrapper = ({
	children,
	show,
	width,
	onDeselectAll,
}: {
	children: React.ReactNode;
	show: boolean;
	width?: string;
	onDeselectAll?: () => void;
}) => {
	const previousShow = usePrevious(show);

	useEffect(() => {
		if (previousShow && !show) {
			onDeselectAll?.();
		}
	}, [onDeselectAll, previousShow, show]);

	return (
		<Box
			xcss={[floatingPositionerStyles]}
			// eslint-disable-next-line jira/react/no-style-attribute -- width of component can change depending on the consumer
			style={{ width: width || '100%' }}
		>
			<ContentSlider show={show}>{children}</ContentSlider>
		</Box>
	);
};

const floatingPositionerStyles = xcss({
	position: 'fixed',
	bottom: 'space.100',
	zIndex: 'layer',
	pointerEvents: 'none',
	display: 'flex',
	justifyContent: 'center',
	transition: 'width 300ms cubic-bezier(0.2, 0, 0, 1)',
});
